import React from 'react';
import { useGetTerminals } from 'api/terminal';
import { GetTerminalParams, Terminal } from 'api/terminal/terminal.types';
import { EditableAutocomplete } from './EditableAutocomplete';

interface EditableTerminalAutocompleteProps {
  value: any;
  onChange: (value: any) => void;
  onSave: (value: any) => void;
  onCancel: () => void;
  disableClearable?: boolean;
}

export const EditableTerminalAutocomplete: React.FC<
  EditableTerminalAutocompleteProps
> = ({ disableClearable = false, ...props }) => (
  <EditableAutocomplete<any, GetTerminalParams>
    {...props}
    useApiHook={useGetTerminals}
    getterName='getTerminals'
    defaultParams={{
      filterText: '',
      resultSize: 25,
      pageNumber: 1,
    }}
    mapOptions={(data: Terminal[]) =>
      data.map((terminal) => ({
        id: terminal.id,
        code: terminal.code,
        address: terminal.address,
        depscription: terminal.description,
        enabled: terminal.enabled,
      }))
    }
    getOptionLabel={(option) => {
      if (typeof option === 'string') return option;
      return option.code || '';
    }}
    isOptionEqualToValue={(option, selectedValue) => {
      if (!selectedValue || selectedValue === '') return false;
      if (typeof selectedValue === 'string') {
        return option.code === selectedValue;
      }
      if (selectedValue?.id === null || selectedValue?.id === undefined) {
        return option.code === selectedValue.code;
      }
      return selectedValue?.id === option?.id;
    }}
    width={undefined}
    disableClearable={disableClearable}
    deduplicateOptions={true}
    deduplicateKey='id'
  />
);
